import { ResponsiveDialog } from 'common-frontend'
import { Button } from 'components'

export default class SimpleDialog extends React.Component {
  static propTypes = {
    title:              React.PropTypes.string.isRequired,
    message:            React.PropTypes.string.isRequired,
    open:               React.PropTypes.bool.isRequired,
    onClose:            React.PropTypes.func,
    modal:              React.PropTypes.bool,
    actionButtonLabel:  React.PropTypes.string
  }
  static defaultProps = {
    modal:             false,
    actionButtonLabel: 'Close'
  }

  constructor(props) {
    super(props)
    this.state = { open: this.props.open }
  }

  componentDidUpdate() {
    this.state = { open: this.props.open }
  }

  handleClose() {
    this.setState({ open: false})

    if (this.props.onClose)
      this.props.onClose()
  }

  render() {
    const actions = [
      <Button
        label={this.props.actionButtonLabel}
        buttonType="secondary"
        onTouchTap={::this.handleClose}
      />
    ]

    return (
      <ResponsiveDialog
        title={this.props.title}
        modal={this.props.modal}
        open={this.state.open}
        onRequestClose={::this.handleClose}
      >
        <div>
          <div className="medium-spacing2--top medium-spacing--bottom">
            {this.props.message}
          </div>
          {actions}
        </div>
      </ResponsiveDialog>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/SimpleDialog.js